module.exports = __webpack_public_path__ + "img/543.484a2eaa.jpg";